import script from "./CookiePolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookiePolicy.vue?vue&type=script&setup=true&lang=ts"

import "./CookiePolicy.vue?vue&type=style&index=0&id=78d7c86b&lang=css"

const __exports__ = script;

export default __exports__